namespace Portico.Models.Enterprise {
    import psgm = apigateway.models;

    export interface IGlobalId {
        id: number;
        type: string;
        value: string;
    }

    export class GlobalId implements IGlobalId {
        id: number;
        type: string;
        value: string;

        constructor(obj?: IGlobalId | any) {
            this.id = null;
            this.type = null;
            this.value = '';

            if(obj) {
                this.id = obj.id || obj.Id || null;
                this.type = obj.type || obj.globalIdTypeCode || null;
                this.value = obj.value || obj.globalId || '';
            }
        }

        mapToEnterpriseCoordinatorGlobalId() : psgm.EnterpriseCoordinatorSharedGlobalIdUpsearchModel {
            return {
                id: this.id,
                globalIdTypeCode : this.type,
                globalId : this.value
            } as psgm.EnterpriseCoordinatorSharedGlobalIdUpsearchModel
        }
    }
}